import ScreenReaderTip from './ScreenReaderTip';

export default ScreenReaderTip;